import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BaseContainerComponent } from './base-container.component';
import { RouterLink, RouterModule, RouterOutlet } from '@angular/router';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { TopNavModule } from '../../top-nav/top-nav.module';
import { PipesModule } from '../../pipes/pipes.module';

@NgModule({
  declarations: [BaseContainerComponent],
  exports: [BaseContainerComponent],
  imports: [
    CommonModule,
    RouterOutlet,
    NgbTooltip,
    TranslateModule,
    RouterLink,
    TopNavModule,
    RouterModule,
    PipesModule,
  ],
})
export class BaseContainerModule {}
